import { useEffect, useRef } from 'react';

const RealTimeWebSocket = ({ onListenerUpdate, onConnectionStatus }) => {
  const wsRef = useRef(null);

  useEffect(() => {
    const connect = () => {
      try {
        console.log('🔌 Starting WebSocket connection...');
        
        // Connect to the stream monitor WebSocket server through nginx proxy
        const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        const host = window.location.host;
        const ws = new WebSocket(`${protocol}//${host}/ws`);
        
        ws.onopen = () => {
          console.log('✅ FIXED: WebSocket connected successfully!');
          onConnectionStatus?.(true);
        };

        ws.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data);
            console.log('📊 FIXED: Received WebSocket data:', data);
            
            if (data.type === 'listener_update' || data.type === 'current_listeners') {
              onListenerUpdate?.(data.data);
            } else if (data.type === 'icecast_update') {
              // Handle Icecast stream data (streams, listeners, etc.)
              console.log('🎵 Received Icecast stream data via WebSocket');
              onListenerUpdate?.(data.data);
            }
          } catch (error) {
            console.error('Error parsing WebSocket message:', error);
          }
        };

        ws.onclose = (event) => {
          console.log('❌ FIXED: WebSocket closed:', event.code, event.reason);
          onConnectionStatus?.(false);
          
          // Simple reconnect after 5 seconds - no complex logic
          setTimeout(() => {
            console.log('🔄 FIXED: Attempting reconnection...');
            connect();
          }, 5000);
        };

        ws.onerror = (error) => {
          console.error('❌ FIXED: WebSocket error:', error);
          onConnectionStatus?.(false);
        };

        wsRef.current = ws;
      } catch (error) {
        console.error('FIXED: Failed to create WebSocket:', error);
        onConnectionStatus?.(false);
        
        // Retry connection after 5 seconds
        setTimeout(connect, 5000);
      }
    };

    // Start the connection
    connect();

    // Cleanup on unmount
    return () => {
      console.log('🧹 FIXED: Cleaning up WebSocket connection');
      if (wsRef.current) {
        wsRef.current.close();
        wsRef.current = null;
      }
    };
  }, [onConnectionStatus, onListenerUpdate]);

  // Component doesn't render anything, just manages WebSocket connection
  return null;
};

export default RealTimeWebSocket;
